import SearchInput from '../../../components/SearchInput'
import {
  TrainingFragment,
  useGetTrainingsByQueryQuery,
} from '../../../generated/urql.anonymous'
import { useCallback, useContext } from 'react'
import { BasketContext, isTrainingBasketItem } from '../../../provider/basket'
import { useI18n } from '../../../provider/i18n'
import { Link, useSearchParams } from 'react-router-dom'
import { TailSpin } from 'react-loader-spinner'
import { Blue300 } from '../../../lib/colors'
import { TrainingItem } from '../../../components/TrainingItem'

const SearchTrainings = () => {
  const [params] = useSearchParams()
  const i18n = useI18n()
  const basket = useContext(BasketContext)
  const query = params.get('q')
  const [{ data: trainingsData, fetching: isFetching }] =
    useGetTrainingsByQueryQuery({
      pause: !query,
      variables: {
        limit: 1000,
        query: query || '',
      },
    })

  const onTrainingAddClick = useCallback(
    (training: TrainingFragment) => {
      basket.addItem({ training })
    },
    [basket]
  )

  const trainings = trainingsData?.search_training || []

  return (
    <div>
      <SearchInput />
      <div className="text-blue-700 my-5 flex gap-1 items-center">
        <span>
          <Link to="/training">
            {i18n.t('screens.catalog.index.trainings.header')}
          </Link>
          {' > '}
          {i18n.t('screens.catalog.search.breadcrumbs.searchResults', {
            query: query || '',
          })}
        </span>
        {isFetching && <TailSpin color={Blue300} height={16} width={16} />}
      </div>
      <ul className="md:mx-5 flex flex-col gap-5 mb-10">
        {trainings.map((training) => (
          <li key={training.id}>
            <TrainingItem
              training={training}
              onTrainingAddClick={() => onTrainingAddClick(training)}
              showAddButton={
                !training.videoFile &&
                !basket.items.find(
                  (item) =>
                    isTrainingBasketItem(item) &&
                    training.id === item.training.id
                )
              }
            />
          </li>
        ))}
      </ul>
    </div>
  )
}

export default SearchTrainings
